// eslint-disable-next-line no-unused-vars
class Carousel {
	constructor(elCarousel, autoAdvance = false, playOnce = false, loop = false) {
		this.GESTURE_SPEED_THRESHOLD = 10;
		this.autoAdvanceDelay = 3000;
		this.loop = loop;
		this.playOnce = this.loop ? false : playOnce;
		this.autoAdvance = this.playOnce ? true : autoAdvance;
		this.durations = {
			NORMAL: 0.6,
			SWIPE: 0.4,
			REWIND: 0.3, // this will multiplied by the number of screens.
		};
		this.elCarousel = elCarousel;
		this.elInner = null;
		this.elBtnPrev = null;
		this.elBtnNext = null;
		this.elTouch = null;
		this.elsThumbs = [];
		this.pos = 0;
		this.x0 = 0;
		this.y0 = 0;
		this.moveDist = 0;
		this.w = 0.0;
		this.speedArr = [];
		this.speed1 = 0;
		this.speed0 = 0;
		this.movedDist = 0;
		this.numScreens = 0;
		this.intId = 0;
		this.intIdPlayOnce = 0;
		this.arrMoveDiff = [];
		this.init();
	}

	/**
	 * PUBLIC METHODS
	 */

	/**
	 * Sets auto-advance
	 * @param bool if true, the Carousel will auto-advance.
	 */
	setAutoAdvance(bool) {
		clearInterval(this.intId);
		if (bool === true) {
			this.autoAdvance = true;
			this.intId = setInterval(() => {
				this.pos += 1;
				this.checkPos();
				this.move();
			}, this.autoAdvanceDelay);
		} else {
			clearInterval(this.intId);
			this.autoAdvance = false;
		}
		this.elCarousel.dispatchEvent(new CustomEvent("autoadvancechange", { detail: { isAuto: bool } }));
	}

	/**
	 * Allows to loop Carousel
	 * @param bool if true, when pressing 'next' at extreme positions will 'rewind' the Carousel.
	 */
	setLoop(bool) {
		this.loop = bool;
		if (bool === true) this.playOnce = false;
		this.checkPos();
	}

	/**
	 * If set to true, the Carousel will return to the 1st slide after it reaches the end.
	 * Setting to true will also enable the autoAdvance feature.
	 * @param bool
	 */
	setPlayOnce(bool) {
		if (this.numScreens > 1) {
			this.playOnce = bool;
			if (bool === true) this.setAutoAdvance(true);
			this.checkPos();
		}
	}

	/**
	 * Sets delay in ms between moving to next slide (when autoAdvance is set to true).
	 * @param num
	 */
	setAutoAdvanceDelay(num) {
		this.autoAdvanceDelay = !Number.isNaN(num) ? num : 3000;
		this.setAutoAdvance(this.autoAdvance);
	}

	/**
	 * PRIVATE METHODS
	 * */

	/**
	 * @private
	 * Initializes this component.
	 */
	init() {
		this.clickHandler = this.clickHandler.bind(this);
		this.pDown = this.pDown.bind(this);
		this.pMove = this.pMove.bind(this);
		this.pUp = this.pUp.bind(this);
		this.elInner = this.elCarousel.querySelector(".carousel_movable");
		this.elTouch = this.elCarousel.querySelector(".carousel_touch-area");
		this.elBtnPrev = this.elCarousel.querySelector('.carousel_buttons > div[data-id="btn-prev"]');
		this.elBtnNext = this.elCarousel.querySelector('.carousel_buttons > div[data-id="btn-next"]');
		this.numScreens = this.elInner.querySelectorAll(".carousel_screen").length;
		if (this.numScreens > 1) {
			this.elBtnPrev.classList.remove("hide");
			this.elBtnNext.classList.remove("hide");
			const posEl = this.elCarousel.querySelector(".carousel_pos");
			let str = "";
			let strThumbs = "";
			const imgs = this.elCarousel.querySelectorAll(".carousel_screen > img");
			for (let i = 0; i < this.numScreens; i += 1) {
				str += `<div class="carousel_pos_btn" data-id="btn-pos" data-pos="${i}"></div>`;
				const src = imgs[i].getAttribute("src");
				const alt = imgs[i].getAttribute("alt");
				strThumbs += `<div class="carousel_thumb" data-id="btn-thumb" data-pos="${i}"><img width="160" height="160" src="${src
					.replace("_600x600_", "_160x160_")
					.replace("_1000x1000_", "_160x160_")}" loading="lazy" alt="${alt}"></div>`;
			}
			this.elCarousel.querySelector(".carousel_thumb-holder").innerHTML = strThumbs;
			this.elsThumbs = this.elCarousel.querySelectorAll(".carousel_thumb");
			posEl.innerHTML = str;
			posEl.addEventListener("click", this.clickHandler);
			this.elCarousel.querySelector(".carousel_buttons").addEventListener("click", this.clickHandler);
			this.elCarousel.querySelector(".carousel_thumb-holder").addEventListener("click", this.clickHandler);
			this.checkPos();

			this.elTouch.addEventListener("touchstart", this.pDown, { passive: true });
			this.elTouch.addEventListener("touchend", this.pUp, { passive: true });
			if (this.autoAdvance) this.setAutoAdvance(true);
		}
	}

	gestureMove(avgSpeed) {
		let increment = this.movedDist > 0 ? -1 : 1;
		if (
			(this.pos === 0 && this.movedDist > 0) ||
			(this.pos === this.numScreens - 1 && this.movedDist < 0) ||
			this.movedDist === 0
		) {
			increment = 0;
		}
		this.pos += increment;
		this.checkPos();
		this.move(avgSpeed);
	}

	resolveGesture(avgSpeed) {
		// Gesture was too slow, move to the nearest pos.
		if (Math.abs(avgSpeed) < this.GESTURE_SPEED_THRESHOLD) {
			if (Math.abs(this.movedDist) >= this.w / 2) {
				this.gestureMove(0);
			} else {
				this.movedDist = 0;
				this.gestureMove(0);
			}
			// Swipe gesture ---------
		} else {
			this.gestureMove(avgSpeed);
		}
	}

	pDown(e) {
		this.removeAuto();
		this.arrMoveDiff = [];
		this.x0 = e.touches[0].clientX - this.moveDist;
		this.y0 = e.touches[0].clientY;
		this.w = this.elInner.getBoundingClientRect().width;
		this.elTouch.addEventListener("touchmove", this.pMove, { passive: true });
		this.elInner.classList.remove("transition");
		this.elInner.classList.remove("transition-gesture");
		this.speedArr = [];
		this.elInner.style.transitionDuration = "0s";
	}

	pMove(e) {
		this.moveDist = e.touches[0].clientX - this.x0;
		const moveX = this.moveDist + this.w * this.pos;
		const prcMove = (moveX / this.w) * 100;
		let newX = (this.moveDist * 100) / this.w;
		// If a user scrolls down, disable the carousel temporarily ----------------
		const diff = Math.abs(e.touches[0].clientY - this.y0) - Math.abs(moveX);
		this.arrMoveDiff.push(diff);
		if (this.arrMoveDiff.length === 5 && this.arrMoveDiff[4] > 0) {
			this.elTouch.removeEventListener("touchmove", this.pMove);
			return;
		}
		// Slow down/restrict movement if at extreme positions ---------------------
		if (this.moveDist > 0 && this.pos === 0) {
			newX /= 3;
		} else if (prcMove < 0 && this.pos === this.numScreens - 1) {
			newX -= prcMove / 1.5;
		}
		// -------------------------------------------------------------------------
		this.elInner.style.transform = `translateX(${newX}%)`;
		this.speedArr.push(this.speed1);
		this.speed1 = this.moveDist - this.speed0;
		this.speed0 = this.moveDist;
	}

	pUp() {
		this.elTouch.removeEventListener("touchmove", this.pMove);
		const num = 5;
		const arr = this.speedArr.slice(this.speedArr.length - num);
		if (arr.length > 0) {
			this.movedDist = this.moveDist + this.w * this.pos;
			const avgSpeed = arr.reduce((a, b) => a + b, 0) / arr.length;
			this.resolveGesture(avgSpeed);
		} else {
			this.resolveGesture(0);
		}
	}

	setTransition(speed) {
		if (speed === 0) {
			this.elInner.style.transitionDuration = `${this.durations.NORMAL}s`;
			this.elInner.style.transitionTimingFunction = "ease-in-out";
		} else if (speed === Infinity) {
			this.elInner.style.transitionDuration = `${this.numScreens * this.durations.REWIND}s`;
			this.elInner.style.transitionTimingFunction = "ease-in-out";
		} else {
			this.elInner.style.transitionDuration = `${this.durations.SWIPE}s`;
			this.elInner.style.transitionTimingFunction = "ease-out";
		}
	}

	removeAuto() {
		clearInterval(this.intId);
		clearTimeout(this.intIdPlayOnce);
		if (this.autoAdvance) this.setAutoAdvance(false);
		this.playOnce = false;
	}

	move(speed = 0) {
		this.w = this.elInner.getBoundingClientRect().width;
		this.setTransition(speed);
		if (this.loop) {
			if (this.pos === this.numScreens) {
				this.pos = 0;
				this.elInner.style.transitionDuration = `${this.numScreens * 0.3}s`;
			} else if (this.pos === -1) {
				this.pos = this.numScreens - 1;
				this.elInner.style.transitionDuration = `${this.numScreens * 0.3}s`;
			}
		} else if (this.pos === this.numScreens - 1) {
			if (this.autoAdvance) this.setAutoAdvance(false);
			if (this.playOnce) {
				setTimeout(() => {
					this.pos = 0;
					this.move(Infinity);
					this.playOnce = false;
				}, this.autoAdvanceDelay);
			}
		}
		this.checkPos();
		const dist = -this.pos * 100;
		this.moveDist = -this.pos * this.w;
		this.elInner.style.transform = `translateX(${dist}%)`;
	}

	clickHandler(e) {
		const id = e.target.getAttribute("data-id");
		if (!id) return;
		switch (id) {
			case "btn-pos":
			case "btn-thumb":
				this.pos = parseInt(e.target.getAttribute("data-pos"), 10);
				break;
			case "btn-prev":
				this.pos -= 1;
				break;
			case "btn-next":
				this.pos += 1;
				break;
			default:
				break;
		}
		this.removeAuto();
		this.checkPos();
		this.move();
	}

	checkPos() {
		if (this.pos === 0) {
			this.elBtnPrev.classList.add("disabled");
		} else {
			this.elBtnPrev.classList.remove("disabled");
		}

		if (this.pos === this.numScreens - 1) {
			this.elBtnNext.classList.add("disabled");
		} else {
			this.elBtnNext.classList.remove("disabled");
		}

		if (this.loop) {
			this.elBtnPrev.classList.remove("disabled");
			this.elBtnNext.classList.remove("disabled");
		}

		this.elCarousel.querySelectorAll("div[data-pos]").forEach((v) => {
			v.classList.remove("selected");
		});
		const current = this.elCarousel.querySelector(`.carousel_pos_btn[data-pos='${this.pos}']`);
		if (current) current.classList.add("selected");
		const currentThumb = this.elCarousel.querySelector(`.carousel_thumb[data-pos='${this.pos}']`);
		if (currentThumb) currentThumb.classList.add("selected");
	}
}
